// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LxQ0kUGooh_gI5YO8W8j {
  background-color: var(--md-grey-color);
  display: flex;
  height: 100vh;
  flex-direction: row;
  overflow: hidden;
}

.GkVwlf0RpMDSzDRebY4a {
  width: 40%;
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
}

.GkVwlf0RpMDSzDRebY4a::-webkit-scrollbar {
  display: none;
}

.CQLTnI_6nnmV0tUaM1bO {
  background-color: var(--md-grey-color);
  width: 60%;
  overflow-y: auto;
  height: 100vh;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.CQLTnI_6nnmV0tUaM1bO::-webkit-scrollbar {
  display: none;
}

.xHdvqpCCpYBNeRJ7SxEB {
  position: sticky;
  top: 0;
  z-index: 10;
}

.SaPu5saawnuHtO9isdVe {
  height: 100%;
}

.SZD4bgapf6ZsxNLN1WDk {
  flex: 1;
  overflow-y: auto;
}

.XDyGir5hXnGEV5hmw4QA {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.a54E4qNAGNawXcwxtN8i {
  color: var(--white-color);
  justify-content: center;
  margin: 0 var(--space-m);
  padding: var(--space-xl) var(--space-m) var(--space-m);
  font-size: var(--step-0);
  display: flex;
  font-weight: bold;
}

@media screen and (max-width: 1024px) {
  .LxQ0kUGooh_gI5YO8W8j {
    flex-direction: column;
    height: auto;
    overflow-y: auto;
  }

  .GkVwlf0RpMDSzDRebY4a {
    width: 100%;
    height: auto;
  }

  .CQLTnI_6nnmV0tUaM1bO {
    width: 100%;
    height: 100vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage/ResultsPage.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,sDAAsD;EACtD,wBAAwB;EACxB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".resultsPage {\n  background-color: var(--md-grey-color);\n  display: flex;\n  height: 100vh;\n  flex-direction: row;\n  overflow: hidden;\n}\n\n.leftSection {\n  width: 40%;\n  height: 100vh;\n  overflow-y: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.leftSection::-webkit-scrollbar {\n  display: none;\n}\n\n.resultsSection {\n  background-color: var(--md-grey-color);\n  width: 60%;\n  overflow-y: auto;\n  height: 100vh;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.resultsSection::-webkit-scrollbar {\n  display: none;\n}\n\n.stickyVideoWrapper {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.videoSection {\n  height: 100%;\n}\n\n.scrollableContent {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.container {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.transcriptsHeader {\n  color: var(--white-color);\n  justify-content: center;\n  margin: 0 var(--space-m);\n  padding: var(--space-xl) var(--space-m) var(--space-m);\n  font-size: var(--step-0);\n  display: flex;\n  font-weight: bold;\n}\n\n@media screen and (max-width: 1024px) {\n  .resultsPage {\n    flex-direction: column;\n    height: auto;\n    overflow-y: auto;\n  }\n\n  .leftSection {\n    width: 100%;\n    height: auto;\n  }\n\n  .resultsSection {\n    width: 100%;\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resultsPage": `LxQ0kUGooh_gI5YO8W8j`,
	"leftSection": `GkVwlf0RpMDSzDRebY4a`,
	"resultsSection": `CQLTnI_6nnmV0tUaM1bO`,
	"stickyVideoWrapper": `xHdvqpCCpYBNeRJ7SxEB`,
	"videoSection": `SaPu5saawnuHtO9isdVe`,
	"scrollableContent": `SZD4bgapf6ZsxNLN1WDk`,
	"container": `XDyGir5hXnGEV5hmw4QA`,
	"transcriptsHeader": `a54E4qNAGNawXcwxtN8i`
};
export default ___CSS_LOADER_EXPORT___;
